(() => {
    class Shop {
        constructor() {
        }
    }
    window.Shop = new Shop();
})();
